import * as React from 'react';
import { AnchorLinkButton, Icons, LinkButton } from 'components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAppState } from 'selectors';
import i18n from 'i18next';

import { actions as appActions } from 'services/app/app-service';
import { actions as overlayActions } from 'services/overlay-windows/overlay-windows-service';

export interface IUserMenuItemsProps {
    onFavClick: () => void;
    onLoginClick?: () => void;
    onLogoutClick?: () => void;
    onCMSClick?: () => void;
}

export const UserMenuItems = (props: IUserMenuItemsProps) => {
    const { t } = useTranslation();
    const appState = useSelector(getAppState);
    const isAuthorized = !!appState.authToken;
    const { authorizationRequired, authorization_allow } = appState.initConfig;

    const renderLoginButton = () => {
        if (authorization_allow) {
            if (isAuthorized) {
                return (
                    <LinkButton
                        icon={<Icons.IconLogout />}
                        label={t('Выход')}
                        onClick={() => {
                            props.onLogoutClick?.();
                            appActions.logout();
                        }}
                        className='user-menu-link-button'
                    />
                );
            } else {
                return (
                    <LinkButton
                        icon={<Icons.IconLogout />}
                        label={t('Вход')}
                        onClick={() => {
                            props.onLoginClick?.();
                            overlayActions.showLoginOverlay();
                        }}
                        className='user-menu-link-button'
                    />
                );
            }
        } else {
            return null;
        }
    };

    return (
        <div className="user-menu-items">
            <div className="menu-list top-menu-list">
                <div className="menu-item">
                    <AnchorLinkButton
                        icon={<Icons.IconCoa3 />}
                        colorIcon={false}
                        href={`https://map.lenoblinvest.ru/${i18n.language === 'en' ? 'en/' : ''}`}
                        label={t('Вернуться на сайт')}
                        className='coa-link-button user-menu-link-button'
                    />
                </div>
                <div className="menu-item">
                    <AnchorLinkButton
                        href={`https://map.lenoblinvest.ru/${i18n.language === 'en' ? 'en/' : ''}#about-project`}
                        label={t('О проекте')}
                        className='user-menu-link-button'
                    />
                </div>
                <div className="menu-item">
                    <AnchorLinkButton
                        href={`https://map.lenoblinvest.ru/${i18n.language === 'en' ? 'en/' : ''}#about-region`}
                        label={t('О регионе')}
                        className='user-menu-link-button'
                    />
                </div>
                {/* <div className="menu-item"> */}
                {/*    <AnchorLinkButton */}
                {/*        href={ */}
                {/*            `https://map.lenoblinvest.ru */}
                {/*            ${i18n.language === 'en' ? '/en' : ''}/development-programs/` */}
                {/*        } */}
                {/*        label={t('Программы развития')} */}
                {/*        className='user-menu-link-button' */}
                {/*    /> */}
                {/* </div> */}
                {/*
                <div className="menu-item">
                    <AnchorLinkButton
                        href='/incentives/'
                        label={t('Льготы')}
                        className='user-menu-link-button'
                    />
                </div>
                */}
            </div>

            <div className="menu-divider" />

            <div className="menu-list bottom-menu-list">
                <div className="menu-item" onClick={props.onFavClick}>
                    <LinkButton
                        icon={<Icons.IconStar />}
                        label={t('Избранное')}
                        className='user-menu-link-button'
                    />
                </div>
                {isAuthorized && props.onCMSClick && (
                    <div className="menu-item" onClick={props.onCMSClick}>
                        <LinkButton
                            icon={<Icons.Settings />}
                            label={t('Администрирование')}
                            className='user-menu-link-button'
                        />
                    </div>
                )}
                <div className="menu-item">
                    { renderLoginButton() }
                </div>
            </div>
        </div>
    );
};
